import styled from 'styled-components';
import createTheme from 'styled-variants';
import { Text } from '@awaze/design-system.components.text';
import { breakpoints, pxToRems } from '@awaze/design-system.utils.react';
import { ReviewsLogo } from './icon';
export const StyledScore = styled.div `
  position: relative;
  display: flex;
  align-items: flex-end;
  flex-direction: column;

  @media (min-width: ${breakpoints[0]}px) {
    margin-bottom: ${pxToRems(24)};
  }
`;
const scoreOutOfStyling = ({ theme }) => ({
    color: theme.ColorGrey600,
    fontFamily: 'Helvetica, Arial, sans-serif',
    fontSize: pxToRems(9),
    lineHeight: pxToRems(8),
    letterSpacing: '-0.02em',
    marginTop: pxToRems(6),
});
const StyledScoreOutOfTheme = createTheme('ScoreOutOf', scoreOutOfStyling);
export const StyledScoreOutOf = styled(Text)(StyledScoreOutOfTheme);
export const StyledScoreRating = styled(Text) `
  font-family: Helvetica, Arial, sans-serif;
  font-size: ${pxToRems(28)};
  line-height: ${pxToRems(22)};
  margin-top: ${pxToRems(10)};
`;
export const StyledReviewsLogo = styled(ReviewsLogo) `
  position: absolute;
  top: -2px;
`;
//# sourceMappingURL=reviews.styles.js.map